import { createSlice } from "@reduxjs/toolkit";

const isBrowser = typeof window !== "undefined";

function getStorage() {
	if (!isBrowser) return null;
	const type = localStorage.getItem("storageType") || sessionStorage.getItem("storageType");
	return type === "session" ? sessionStorage : localStorage;
}

const initialToken = isBrowser
	? localStorage.getItem("token") || sessionStorage.getItem("token")
	: "";
const initialUser = isBrowser
	? JSON.parse(localStorage.getItem("user") || sessionStorage.getItem("user") || "{}")
	: {};

const initialState = {
	token: initialToken || '',
	user: initialUser || {}
};

export const userSlice = createSlice({
    name: "user-slice",
    initialState,
    reducers: {
      loginUser: (state, { payload: { token, user }}) => {
				state.token = token;
				state.user = user;
			const storage = getStorage();
			if (storage) {
				storage.setItem("token", token);
				storage.setItem("user", JSON.stringify(user));
			}
      },
      logoutUser: (state) => {
				state.token = "";
				state.user = {};
			if (isBrowser) {
				// Remove from both storages for safety
				localStorage.removeItem("token");
				localStorage.removeItem("user");
				localStorage.removeItem("storageType");
				sessionStorage.removeItem("token");
				sessionStorage.removeItem("user");
				sessionStorage.removeItem("storageType");
			}
      },
      updateUser: (state, { payload }) => {
        const updateUser = { ...state.user, ...payload }
			state.user = updateUser;
			const storage = getStorage();
			if (storage) {
				storage.setItem("user", JSON.stringify(updateUser));
			}
      }
    },
});

export const {
    loginUser,
    logoutUser,
    updateUser
} = userSlice.actions;
export default userSlice.reducer;
